import {TodoCompletion, TodoDetails} from '../../../../api';
import {TodoFormValue} from '../models/todo-form-value';

export function mapTodoDetailsToFormValue(todo: TodoDetails): TodoFormValue | undefined {
  if (!todo.status?.id) return undefined;
  return {
    id: todo.id,
    title: todo.title,
    description: todo.description ?? null,
    dueDate: todo.dueDate ?? null,
    concernId: todo.concern?.id ?? null,
    priorityName: todo.priority?.id ?? null,
    estimatedTimeInDays: todo.estimatedTimeInDays ?? null,
    statusId: todo.status.id,
    isPrivate: todo.isPrivate ?? null,
    isDone: todo.completion === TodoCompletion.DONE,
    assignedToIds: todo.assignees?.map(a => a.id!).filter(id => id != null) ?? null,
    children: todo.children?.map(s => ({
      id: s.id,
      title: s.title,
      dueDate: s.dueDate ?? null,
      assignedToId: s.assignees?.[0]?.id ?? null,
      isDone: s.completion === TodoCompletion.DONE,
    })) ?? [],
  };
}
